const getters = {
  sidebarIsClose: state => state.app.sidebarIsClose,
  
  userInfo: state => state.app.userInfo,
  dictionaries: state => state.app.dictionaries,
  weekList: state => state.app.weekList,
  lineTypeList: state => state.app.lineTypeList,
  spaceStatusList: state => state.app.spaceStatusList,


  iconList: state => state.icon.iconList,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js